import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M853.363 170.667h-682.665c-46.933 0-85.333 38.4-85.333 85.333v512c0 46.933 38.4 85.333 85.333 85.333h682.665c46.933 0 85.333-38.4 85.333-85.333v-512c0-46.933-38.4-85.333-85.333-85.333zM836.297 352l-279.040 174.507c-27.733 17.493-62.72 17.493-90.453 0l-279.039-174.507c-10.667-6.827-17.067-18.347-17.067-30.72 0-28.587 31.147-45.653 55.467-30.72l285.865 178.773 285.867-178.773c24.32-14.933 55.467 2.133 55.467 30.72 0 12.373-6.4 23.893-17.067 30.72z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgMail);
export default ForwardRef;
